module.exports = __webpack_public_path__ + "media/img/frontend_application/upload-icon-f63bbf9e2cb127be3c1056895c29622d.jpg";